// apiConfig.js
let BASE_URL = "";
if (process.env.REACT_APP_NODE_ENV === "dev") {
  BASE_URL = "http://localhost:3000/api/v1";
} else {
  BASE_URL = "https://clocked-app.onrender.com/api/v1";
}
export default BASE_URL;
